import { mergeClasses } from '@/utils';

import { BUTTON_VARIANTS, ICON_VARIANTS } from './Button.constants';
import { IButton } from './Button.interfaces';

const Button = ({
  className,
  variant = 'primary',
  size = 'default',
  borderRadius = 'default',
  prefixIcon,
  suffixIcon,
  children,
  ...props
}: IButton) => {
  return (
    <button
      data-slot="button"
      data-variant={variant}
      data-size={size}
      data-border-radius={borderRadius}
      className={mergeClasses(BUTTON_VARIANTS({ variant, size, borderRadius, className }))}
      {...props}
    >
      {prefixIcon ? (
        <span className={mergeClasses(ICON_VARIANTS({ size }))}>{prefixIcon}</span>
      ) : null}
      {children}
      {suffixIcon ? (
        <span className={mergeClasses(ICON_VARIANTS({ size }))}>{suffixIcon}</span>
      ) : null}
    </button>
  );
};

export { Button, BUTTON_VARIANTS, ICON_VARIANTS };
